// GENERATED by docs/topics/engine-catalog/sync.py — do not edit.
// The cloud wizard's supported PDF formats. Edit engines.yaml + re-run sync.

export interface CloudEngine {
  id: string;
  display: string;
  exportLabel: string;
  /** How to produce the file — the manifest's export_how_to, shown in
   *  the wizard's 'need help getting your file?' accordion. */
  howTo: string;
  /** The app's own export-help page (manifest help_url); '' if none. */
  helpUrl: string;
}

export const CLOUD_ENGINES: CloudEngine[] = [
  {
    id: "ofw",
    display: "OurFamilyWizard",
    exportLabel: "“Messages Report” PDF, any layout",
    howTo: "The PDF you download from the Messages page in OurFamilyWizard (the Download icon, then Download Messages). The older \"Message Report\" and the redesigned \"Messages Report\" both work, grouped by conversation or as individual messages. Not a browser \"print to PDF\", which Aurora can't parse. Dates, senders, and message bodies carry through; attachments are referenced, not included.",
    helpUrl: "https://www.ourfamilywizard.com/knowledge-center/tips-tricks/parents-website/printing-all-messages",
  },
  {
    id: "civil-communicator",
    display: "Civil Communicator",
    exportLabel: "messages PDF",
    howTo: "The message export Civil Communicator produces for your case. Aurora reads it directly — no conversion step.",
    helpUrl: "https://www.support.civilcommunicator.com/communication-report",
  },
  {
    id: "two-houses",
    display: "2houses",
    exportLabel: "conversations PDF",
    howTo: "In 2houses, open your conversation with the other parent and export it as a PDF — the export is always the complete thread (2houses offers no date-range or other settings), which suits Aurora: the whole record, nothing filtered. Hand Aurora that file — no conversion step.",
    helpUrl: "https://intercom.help/2houses/en/articles/495376-print-or-export-messages-in-2houses",
  },
  {
    id: "talking-parents",
    display: "TalkingParents",
    exportLabel: "“Complete Message Record” PDF",
    howTo: "The certified PDF from TalkingParents' PDF Records section — the file titled \"Complete Message Record\", with the authentication code at the bottom of every page. TalkingParents charges a fee for this export.",
    helpUrl: "https://support.talkingparents.com/hc/en-us/articles/25976762956567-How-do-I-obtain-my-Record",
  },
  {
    id: "appclose",
    display: "AppClose",
    exportLabel: "records export PDF",
    howTo: "The records export AppClose emails you — one PDF holding your messages plus the photos and files attached to them. Hand Aurora that file; no conversion step. Aurora records that an attachment was sent, and its filename, but does not open or read the files themselves.",
    helpUrl: "https://support.appclose.com/hc/en-us/articles/360045648731-Records-Export",
  },
];
